import { useContext } from "react"
import { TargetContext } from "./target.context";

export const useTarget = () => {
    const context = useContext(TargetContext)
    if (context === undefined){
        throw new Error(`Component is not inside TargetContext scope`);
    }
    return context
}